import React from "react"
import { PROCESS_ENV } from "~Shared/config/env.utils"

export const LoginLogo = () => (
    <div className="w-full flex flex-row items-center -center justify-center p-28 z-50">
        <img src={"./images/logo.svg"} className="h-36" alt={"FINWAY"} />
        {PROCESS_ENV.IS_USING_CHRISTMAS_THEME && <img src="/images/snow_man.png" alt="finway snow man" className="w-32" />}
    </div>
)
